// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__UgyTz","title":"BackImages_title__lkH5D","images":"BackImages_images__owNW6"};